'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageMusicNote = function ImageMusicNote(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z' })
  );
};
ImageMusicNote = (0, _pure2.default)(ImageMusicNote);
ImageMusicNote.displayName = 'ImageMusicNote';

exports.default = ImageMusicNote;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/image/music-note.js
 ** module id = 1648
 ** module chunks = 0
 **/